import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2, RotateCcw, AlertTriangle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ArticleRecycleBin() {
  const [deletedArticles, setDeletedArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeletedArticles();
  }, []);

  const fetchDeletedArticles = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/articles?deleted=true');
      setDeletedArticles(response.data);
    } catch (error) {
      console.error("Failed to fetch deleted articles:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleRestore = async (id) => {
      try {
          await axios.put(`/api/articles/bulk/action`, { ids: [id], action: 'restore' }); // Assuming a 'restore' action
          fetchDeletedArticles();
      } catch (error) {
          alert('恢复失败!');
      }
  };
  
  const handleHardDelete = async (id) => {
      if(window.confirm('此操作将永久删除文章，无法恢复。您确定吗？')) {
          try {
              // This should be a hard delete endpoint
              await axios.delete(`/api/articles/${id}/hard`); 
              fetchDeletedArticles();
          } catch(error) {
              alert('永久删除失败!');
          }
      }
  };

  if (loading) return <div className="p-8 text-center text-gray-500">加载中...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-full">
      <div className="flex items-center gap-4 mb-6"><Link to="/content/articles" className="p-2 text-gray-500 hover:text-gray-900 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors"><ArrowLeft className="w-5 h-5" /></Link><h1 className="text-2xl font-semibold flex items-center gap-2 text-gray-800"><Trash2 className="w-6 h-6 text-red-500" />文章回收站</h1></div>
      {deletedArticles.length === 0 ? (
        <p className="text-gray-500">回收站是空的。</p>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="bg-gray-50/80 text-gray-500 text-xs uppercase">
              <tr>
                <th className="px-6 py-3">标题</th>
                <th className="px-6 py-3">删除时间</th>
                <th className="px-6 py-3 text-right">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {deletedArticles.map(article => (
                <tr key={article.id}>
                  <td className="px-6 py-4 font-semibold text-gray-800">{article.title}</td>
                  <td className="px-6 py-4 text-gray-500">{new Date(article.updatedAt).toLocaleString()}</td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button onClick={() => handleRestore(article.id)} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-500 text-white rounded-md hover:bg-green-600 text-xs"><RotateCcw className="w-3 h-3"/>恢复</button>
                      <button onClick={() => handleHardDelete(article.id)} className="flex items-center gap-1.5 px-3 py-1.5 bg-red-600 text-white rounded-md hover:bg-red-700 text-xs"><AlertTriangle className="w-3 h-3"/>永久删除</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
